<template>
  <div>
    <v-list-item-avatar
      v-if="loading"
      :color="src == '' ? 'rgba( 241, 95, 49, 0.24)' : 'white'"
    >
      <v-skeleton-loader type="avatar"></v-skeleton-loader>
    </v-list-item-avatar>
    <v-list-item-avatar
      v-else
      :color="src == '' ? 'rgba( 241, 95, 49, 0.24)' : 'white'"
      :size="size"
    >
      <img v-if="src != ''" :src="src" />
      <span v-else class="white--text text-uppercase">{{ usersInitials }}</span>
    </v-list-item-avatar>
  </div>
</template>
<script>

import {getDownloadUrlForRef, getStorageRef} from "@/shared/firebase_utils";

export default {
  name: "UserAvatar",
  props: {
    displayImageUrl: {
      type: String,
      default: "",
    },
    usersInitials: {
      type: String,
      default: "",
    },
    businessCardId: {
      type: String,
      default: "",
    },
    uid: {
      type: String,
      default: "",
    },
    size: {
      type: Number,
      default: 40,
    }
  },
  data() {
    return {
      src: "",
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    this.src = this.displayImageUrl;
    if (this.src == "" && this.businessCardId != "") {
      //Retrieve the users displayImageURl if it exists and update the displayImageURl
      await this.setSrcFromBusinessCardId();
    }
    if (this.src == "" && this.uid != "") {
      //Retrieve the users displayImageURl if it exists and update the displayImageURl
      await this.setSrcFromUid();
    }
    this.loading = false;
  },
  methods: {
    async setSrcFromBusinessCardId() {
      //Start: Get the displayImage url for the businessCardId

      try {
        this.src = await getDownloadUrlForRef(getStorageRef(`businessCardDisplayImages/${this.businessCardId}.png`));
      } catch (error) {
        //No display image found
        this.src = "";
      }
      //End: Get the displayImage url for the businessCardId
    },
    async setSrcFromUid() {
      //Start: Get the displayImage url for the uid
      try {
        this.src = await getDownloadUrlForRef(getStorageRef(`userDisplayImages/${this.uid}.png`));
      } catch (error) {
        //No display image found
        this.src = "";
      }
      //End: Get the displayImage url for the uid
    },
  },
};
</script>
<style scoped>
.v-list-item__avatar {
  justify-content: center;
}
</style>
